import React, { useState } from "react";
import { verifyAdminCodeApi } from "../../api/users/userApi";
import { useUser } from "../../context/UserContext";
import { toast } from "react-toastify";

interface OtpModalProps {
  requestId: string; 
  onClose: () => void;
  onSuccess: () => void; 
}

const OtpModal: React.FC<OtpModalProps> = ({
  requestId,
  onClose,
  onSuccess,
}) => {
  const { user } = useUser();

  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);

  const handleVerify = async () => {
    if (!user?.org_id) {
      toast.error("Organization not found");
      return;
    }

    if (!/^\d{6}$/.test(otp)) {
      toast.error("Please enter a valid 6 digit OTP");
      return;
    }

    const orgId = user.org_id;

    try {
      setLoading(true);

      await verifyAdminCodeApi(orgId, {
        request_id: requestId,
        verification_code: otp,
      });

      toast.success("OTP verified successfully");
      onSuccess(); 
    } catch (err: any) {
      const message = err?.response?.data?.message;

      if (message === "Invalid verification code") {
        toast.error("Incorrect OTP. Please try again.");
      } else if (message === "Verification code expired") {
        toast.error("OTP expired. Please request a new one.");
      } else {
        toast.error("Failed to verify OTP");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal otp-modal">
        <div className="modal__header">
          <h3>Verify OTP</h3>
          <button className="close-btn" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="modal__body">
          <p className="otp-info">
            An OTP has been sent to your registered email address.
          </p>

          <input
            className="otp-input"
            placeholder="Enter OTP"
            value={otp}
            maxLength={6}
            onChange={(e) => setOtp(e.target.value)}
          />
        </div>

        <div className="modal__footer">
          <button
            className="secondary-btn"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            className="primary-btn"
            onClick={handleVerify}
            disabled={loading}
          >
            Verify OTP
          </button>
        </div>
      </div>
    </div>
  );
};

export default OtpModal;
